import { Field, Form, Formik, FormikHelpers, FormikProps } from 'formik'
import * as yup from 'yup'
import React from 'react'
import { login } from './helpers'
import { isAuthenticated } from './../../helpers/auth'
import { Redirect, RouteComponentProps } from 'react-router'
import { Button, TextInput } from '@mantine/core'
import { enterpriseLockupLogo } from '../../assets/viveka-logos'

interface IFormFields {
  email: string
  password: string
}

interface IProps extends RouteComponentProps {}

const LoginPage: React.FC<IProps> = ({ history }) => {
  if (isAuthenticated()) {
    return <Redirect to="/" />
  }

  const initialValues: IFormFields = {
    email: '',
    password: '',
  }

  const onSubmit = (values: IFormFields, formikHelpers: FormikHelpers<IFormFields>) => {
    login(values).finally(() => {
      formikHelpers.setSubmitting(false)
      history.push('/')
    })
  }

  const validationSchema = yup.object({
    email: yup.string().label('Email').required().email(),
    password: yup.string().label('Password').required(),
  })

  return (
    <div className="min-h-screen bg-[#F4F7FC] flex items-center justify-center">
      <div className="w-full max-w-sm bg-white rounded-xl shadow-md p-8">
        <img alt="Viveka" src={enterpriseLockupLogo} className="h-8 mb-6" />
        <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={validationSchema}>
          {(formikProps: FormikProps<IFormFields>) => {
            return (
              <Form className="flex flex-col gap-5">
                <p className="text-xl font-bold text-[#0B1D3A]">Super admin login</p>
                <Field as={TextInput} name="email" label="Email" required />

                <Field as={TextInput} type="password" name="password" label="Password" required />

                <Button
                  type="submit"
                  disabled={formikProps.isSubmitting || !formikProps.isValid || !formikProps.dirty}
                >
                  Login
                </Button>
              </Form>
            )
          }}
        </Formik>
      </div>
    </div>
  )
}

export default LoginPage
